import React from 'react';
import styles from './TipAmountButton.module.css';

const TipAmountButton = ({ amount, isSelected, onClick }) => {
    return (
        <button
            className={`${styles.button} ${isSelected ? styles.selected : ''}`}
            onClick={onClick}
        >
            {amount}$
        </button>
    );
};

export default TipAmountButton;
